import { useState, useCallback } from 'react';
import { SCANNED_VALUE_DATA_TYPES } from '../constants';

export function useAlphanumericInput(initialValue = '') {
	const [value, setValue] = useState(initialValue);

	const sanitizeValue = useCallback((input, type) => {
		if (type === SCANNED_VALUE_DATA_TYPES.NUMBER) {
			return input.replace(/[^0-9]/g, '');
		} else if (type === SCANNED_VALUE_DATA_TYPES.ALPHA_NUMERIC) {
			return input.replace(/[^a-zA-Z0-9]/g, '');
		} else if (type === SCANNED_VALUE_DATA_TYPES.ALPHABET) {
			return input.replace(/[^a-zA-Z]/g, '');
		} else {
			return input;
		}
	}, []);

	const handleChange = useCallback(
  (e, type, caseType = 'none') => {
    const input = e.target;
    const inputValue = input.value;
    let cleaned = sanitizeValue(inputValue, type);

    if (caseType === 'uppercase') {
      cleaned = cleaned.toUpperCase();
    } else if (caseType === 'lowercase') {
      cleaned = cleaned.toLowerCase();
    }

    const { selectionStart, selectionEnd } = input;

    setValue((prev) => {
      // update value and preserve cursor
      const newValue = cleaned;
      // calculate cursor offset if needed
      const cursorPos = selectionStart + (newValue.length - inputValue.length);

      // Restore cursor after render
      requestAnimationFrame(() => {
        input.setSelectionRange(cursorPos, cursorPos);
      });

      return newValue;
    });
  },
  [sanitizeValue]
);

	const handlePaste = useCallback(
		(e, type, caseType = 'none') => {
			e.preventDefault();
			const pastedText = e.clipboardData.getData('text');
			let cleaned = sanitizeValue(pastedText, type);

			if (caseType === 'uppercase') {
				cleaned = cleaned.toUpperCase();
			} else if (caseType === 'lowercase') {
				cleaned = cleaned.toLowerCase();
			}

			const input = e.target;
			const { selectionStart, selectionEnd } = input;

			setValue((prev) => {
				return (
					prev.slice(0, selectionStart) + cleaned + prev.slice(selectionEnd)
				);
			});

			requestAnimationFrame(() => {
				input.selectionStart = input.selectionEnd =
					selectionStart + cleaned.length;
			});
		},
		[sanitizeValue],
	);

	const reset = useCallback(() => setValue(''), []);

	return {
		value,
		setValue,
		handleChange,
		handlePaste,
		reset,
	};
}
